import { Divider } from 'components';
import styled from '@emotion/styled';
import { NextIcon } from 'components/Icon';
const StyledSidebar = styled.div(props => ({
  backgroundColor: 'var(--primary-color)',
  width: '240px',
  minWidth: '240px'
}));

const StyledSidebarItem = styled.div(props => (
  {
    minHeight: '64px',
    backgroundColor: props.active ? 'var(--white-20-color)' : 'transparent',
    display: 'flex',
    alignItems: 'center',
    padding: '0 32px',
    '&:hover' : {
      backgroundColor: 'var(--white-20-color)',
      cursor: 'pointer'
    }
  }
));

const StyledButtonLogInOut = styled.button(props => ({
  marginTop: 91,
  backgroundColor: props.isLogin ? 'var(--white-color)' : 'var(--white-20-color)',
  color: props.isLogin ? 'var(--primary-color)' : 'var(--white-color)',
  width: 176,
  marginRight: 32,
  marginLeft: 32,
  height: 40,
  border: 'none',
  borderRadius: 54,
  fontSize: 16,
  lineHeight: '26px',
  fontWeight: 600
}));

const MenuNextIcon = styled(NextIcon)({
  position: 'absolute',
  right: 32,
  top: '50%',
  transform: 'translateY(-50%)'
})

const StyledDivider = styled(Divider)({
  left: 32,
  right: 32,
  width: 'calc(100% - 64px)',
  backgroundColor: 'var(--white-30-color)',
})

export {
  StyledSidebar,
  StyledSidebarItem,
  MenuNextIcon,
  StyledDivider,
  StyledButtonLogInOut
}
